import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { updateUserName } from '../services/auth';
import { Modal, Button } from './index';

interface NamePromptProps {
  onComplete: () => void;
}

export function NamePrompt({ onComplete }: NamePromptProps) {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;

    setSaving(true);
    setError(null);
    try {
      await updateUserName(name.trim());
      onComplete();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save name');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen onClose={() => {}} title={t('app.namePrompt.modalTitle')}>
      <form onSubmit={handleSubmit}>
        <p style={{ marginBottom: '12px' }}>
          {t('app.namePrompt.description')}
        </p>
        <input
          className="input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t('app.namePrompt.placeholder')}
          autoFocus
          disabled={saving}
        />
        {error && <p style={{ color: 'var(--color-error)', marginTop: '8px', fontSize: '14px' }}>{error}</p>}
        <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" disabled={saving || !name.trim()}>
            {saving ? t('app.namePrompt.saving') : t('app.namePrompt.continue')}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
